package app.smartcoding.realrate.presentation.components

import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.dp
import app.smartcoding.realrate.domain.model.CreditRating
import app.smartcoding.realrate.presentation.util.formatNumberWithSpaces
import io.github.koalaplot.core.ChartLayout
import io.github.koalaplot.core.animation.StartAnimationUseCase
import io.github.koalaplot.core.bar.DefaultBarPosition
import io.github.koalaplot.core.bar.DefaultHorizontalBarPlotEntry
import io.github.koalaplot.core.bar.HorizontalBarPlot
import io.github.koalaplot.core.bar.horizontalSolidBar
import io.github.koalaplot.core.style.KoalaPlotTheme
import io.github.koalaplot.core.util.ExperimentalKoalaPlotApi
import io.github.koalaplot.core.xygraph.AxisContent
import io.github.koalaplot.core.xygraph.AxisStyle
import io.github.koalaplot.core.xygraph.TickPosition
import io.github.koalaplot.core.xygraph.XYGraph
import io.github.koalaplot.core.xygraph.rememberIntLinearAxisModel

@OptIn(ExperimentalKoalaPlotApi::class)
@Composable
fun CreditCostChart(
    totalPayment: Double,
    principal: Double,
    modifier: Modifier = Modifier.Companion
) {
    ChartLayout(
        modifier = modifier.fillMaxWidth().height(80.dp)
    ) {
        val xAxisModel = rememberIntLinearAxisModel(
            range = 0..(totalPayment * 1.05).toInt()
        )
        val yAxisModel = rememberIntLinearAxisModel(
            range = 0..4,
            maxViewExtent = 2,
            minimumMajorTickIncrement = 2
        )

        XYGraph(
            xAxisModel = xAxisModel,
            yAxisModel = yAxisModel,
            xAxisContent = AxisContent(
                labels = {
                    Text(it.toLong().formatNumberWithSpaces(), style = MaterialTheme.typography.labelSmall)
                },
                title = {},
                style = AxisStyle(
                    majorTickSize = 4.dp,
                    tickPosition = TickPosition.Outside,
                )
            ),
            yAxisContent =  AxisContent(
                labels = {
                    Text("$it", style = MaterialTheme.typography.labelSmall)
                },
                title = {},
                style = AxisStyle(
                    majorTickSize = 4.dp,
                    tickPosition = TickPosition.Outside,
                )
            ),
        ) {
            HorizontalBarPlot(
                data = listOf(
                    DefaultHorizontalBarPlotEntry(
                        y = 1,
                        x = DefaultBarPosition(0, principal.toInt())
                    )
                ),
                bar = horizontalSolidBar(
                    color = CreditRating.EXCELLENT.color
                ),
                startAnimationUseCase = StartAnimationUseCase(
                    executionType = StartAnimationUseCase.ExecutionType.None,
                    KoalaPlotTheme.animationSpec
                )
            )
            HorizontalBarPlot(
                data = listOf(
                    DefaultHorizontalBarPlotEntry(
                        y = 1,
                        x = DefaultBarPosition(principal.toInt(), totalPayment.toInt())
                    )
                ),
                bar = horizontalSolidBar(color = CreditRating.BAD.color),
                startAnimationUseCase = StartAnimationUseCase(
                    executionType = StartAnimationUseCase.ExecutionType.None,
                    KoalaPlotTheme.animationSpec
                )
            )
        }
    }
}